    angular.module('qkr')
        .controller('commonModalDialogController', commonModalDialogController);

    function commonModalDialogController($scope, $uibModalInstance, confirmMsg, title, confirmButtonName,
                                         multiMsgArray) {
        const vm = $scope;

        vm.confirmMsg = confirmMsg;
        vm.title = title;
        vm.multiMsgArray = multiMsgArray;
        vm.confirmButtonName = confirmButtonName;
        vm.errors = {};

        vm.ok = function() {
            $uibModalInstance.close('ok');
        };

        vm.cancel = function() {
            $uibModalInstance.close('cancel');
        };
    }



// WEBPACK FOOTER //
// ./src/controllers/modal/common.dialog.controller.js